// API configuration and utilities

export const API_URL = process.env.REACT_APP_API_URL || 
  (process.env.NODE_ENV === 'production' 
    ? 'https://teenagefashion.in/backend/api' 
    : 'http://localhost/newfashion/backend/api');

// Simple storage manager
const storageManager = {
  setItem: (key, value) => {
    try {
      localStorage.setItem(key, value);
      sessionStorage.setItem(key, value);
    } catch (error) {
      console.warn('Storage failed:', error);
    }
  },
  
  getItem: (key) => {
    try {
      return localStorage.getItem(key) || sessionStorage.getItem(key);
    } catch (error) {
      console.warn('Storage read failed:', error);
      return null;
    }
  },
  
  removeItem: (key) => {
    try {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    } catch (error) {
      console.warn('Storage remove failed:', error);
    }
  }
};

// Utility function to handle API calls with session validation
export const apiCall = async (endpoint, options = {}) => {
  const defaultOptions = {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers
    }
  };

  const finalOptions = { ...defaultOptions, ...options };

  try {
    const response = await fetch(`${API_URL}/${endpoint}`, finalOptions);
    
    // If session expired, clear auth data
    if (response.status === 401) {
      storageManager.removeItem('authToken');
      throw new Error('Session expired');
    }
    
    return response;
  } catch (error) {
    if (error.message === 'Session expired') {
      throw error;
    }
    throw new Error('Network error');
  }
};

// Helper function to check if session is valid
export const checkSession = async () => {
  try {
    const response = await apiCall('validate_session.php');
    return response.ok;
  } catch (error) {
    return false;
  }
}; 